import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';
import LocationCarousel from './LocationCarousel';

function Services() {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <h1>Services at All Star Logistics</h1>
          <p className="subtitle">A Decade of Excellence in Waste Management</p>
        </div>
      </section>

      {/* Company Overview
      <section className="company-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-content" style={{ fontSize: '1.25rem' }}>
              <h2>Our Services</h2>
              <p>
                All Star Logistics Partners has been providing top-notch dumpster rental services for over a decade.
                We pride ourselves on reliability, exceptional customer service, and a commitment to meeting
                our clients' needs throughout Alabama.
              </p>
              <p>
                Our team of experienced professionals understands the importance of timely service and efficient
                waste management solutions for both residential and commercial projects.
              </p>
            </div>
            <div className="overview-stats">
              <div className="stat-card">
                <h3>10+</h3>
                <p>Years of Experience</p>
              </div>
              <div className="stat-card">
                <h3>1000+</h3>
                <p>Completed Orders</p>
              </div>
              <div className="stat-card">
                <h3>24/7</h3>
                <p>Customer Support</p>
              </div>
            </div>
          </div>
        </div>
      </section>
       */}
    {/* Services Section */}
    <section className="services" id="services">
            <div className="container">
              <h2 className="section-title">Our Services</h2>
              <div className="services-grid">
                <div className="service-card">
                  <img 
                    src={`${process.env.PUBLIC_URL}/images/construction.webp`} 
                    alt="Construction waste" 
                  />
                  <h3>Construction</h3>
                  <p>Perfect for renovation and construction projects</p>
                </div>
                <div className="service-card">
                  <img 
                    src={`${process.env.PUBLIC_URL}/images/garbage_rental.jpeg`} 
                    alt="Residential cleanup" 
                  />
                  <h3>Residential</h3>
                  <p>Ideal for home cleanouts and yard waste</p>
                </div>
                <div className="service-card">
                  <img 
                    src={`${process.env.PUBLIC_URL}/images/commercial.png`} 
                    alt="Commercial services" 
                  />
                  <h3>Commercial</h3>
                  <p>Solutions for businesses and industrial needs</p>
                </div>
              </div>
            </div>
          </section>

      {/* Locations Section */}
      <section className="locations">
        <div className="container">
          <h2 className="section-title">Service Areas</h2>
          <p className="section-description">
            Serving Muscle Shoals, Decatur, Florence and surrounding areas for over 10 years.
          </p>
          <LocationCarousel />
        </div>
      </section>

      {/* Equipment Section */}
      <section className="equipment-section">
        <div className="container">
          <h2>Our Equipment</h2>
          <p className="section-description" style={{ fontSize: '1.5rem' }}>
            We maintain a fleet of well-maintained 30-yard dumpsters designed to handle large debris loads efficiently.
          </p>
          <div className="equipment-details">
            <div className="specs-grid">
              <div className="spec-card">
                <h3>Dimensions</h3>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/container-sizes.png`}
                  alt="Dumpster dimensions"
                  className="spec-image"
                />
                <h3 style={{ color: '#006400' }}><strong>40 Yard Container</strong></h3>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/40-Yard-Roll-off-Dumpster.jpg`}
                  alt="Dumpster dimensions"
                  className="spec-image"
                />
              </div>

              {/* 20 Yard- 120 trash bags or 6 pick up trucks load */}
              <div className="spec-card">
                <h3>Capacity</h3>
                <ul className="spec-list" style={{ fontSize: '1.25rem' }}>
                  <li><strong>20 Yard</strong></li>
                  <li>120 trash bags</li>
                  <li>6 pick up trucks load</li>
                </ul>
                {/* 30 yard- 180 trash bags, 9 pick up trucks */}
                <ul className="spec-list" style={{ fontSize: '1.25rem' }}>
                  <li><strong>30 Yard</strong></li>
                  <li>180 trash bags</li>
                  <li>9 pick up trucks load</li>
                </ul>
                {/* 40 yard- 240 trash bags, or 12 pick up trucks */}
                <ul className="spec-list" style={{ fontSize: '1.25rem' }}>
                  <li><strong>40 Yard</strong></li>
                  <li>240 trash bags</li>
                  <li>12 pick up trucks load</li>
                </ul>
              </div>
              
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section">
        {/* Pricing Section */}
      {/* Short Term Pricing- 350 dollars for 5 days, extra days charged at $25/day. Two ton limit with a $50/ton overweight fee. */}
        <div className="container">
          <h2>Transparent Pricing</h2>
          <div className="price-cards">
            <div className="price-card">
              <h4>Short Term Pricing</h4>
              <p className="price">$350 for 5 days</p>
              <p className="duration">+ $25 each additional day for up to 5 days</p>
              <ul className="price-features">
                <li>Two ton limit with a $50/ton overweight fee</li>
                <li><i className="fas fa-truck"></i> Delivery included</li>
                <li><i className="fas fa-undo"></i> Pickup included</li>
              </ul>
            </div>
            {/* <div className="price-card featured">
              <h4>Long-Term Rental</h4>
              <p className="price">$595</p>
              <p className="duration">10 days</p>
              <ul className="price-features">
                <li><i className="fas fa-truck"></i> Delivery included</li>
                <li><i className="fas fa-undo"></i> Pickup included</li> <br></br>
                <li>For 10+ days, please contact us at</li>
                <li><a href="tel:+12563666679" className="contact-link">(256) 366-6679</a> </li> 
                <li>or email </li>
                <li><a href="mailto:sales@allstarrecycling.net" className="contact-link">sales@allstarrecycling.net</a></li>
             
              </ul>
            </div> */}
            {/* Long Term Pricing- Ask for Quote here */}


            <div className="price-card">
              <h4>Long Term Pricing</h4>
              <p className="price">Ask for Quote</p>
              <ul className="price-features">
                <Link to="/booking" className="quote-button">Get a Quote</Link>
              </ul>
            </div>
          </div>
        </div>
      </section>
    
    </div>
  );
}

export default Services;
